import { observer } from 'mobx-react';
import React from 'react';

import { useTranslation } from 'react-i18next';

import { WrappedNavLink } from '@components/navigation';
import { useRootAppStore } from '@hooks';
import { THEME_SETTINGS } from '@theme-settings';
import { getCurrentCulture } from '@utils';

export const ChangeShopButton = observer(function ChangeShopButton(props: {
	setIsNavMenuOpen: (value: boolean) => void;
}) {
	const t = useTranslation().t;
	const rootStore = useRootAppStore();

	if (THEME_SETTINGS.isDKMW || !rootStore.userAuthStore.isMultiCardUser) {
		return null;
	}

	return (
		<WrappedNavLink
			className="btn btn--med btn--block btn--icon btn--accent"
			to={`/${getCurrentCulture()}/auth/change-shop`}
			onClick={() => {
				props.setIsNavMenuOpen(false);
			}}
		>
			<span>{t('CHANGE_SHOP_PAGE.CHANGE_SHOP_TITLE')}</span>
		</WrappedNavLink>
	);
});
